// aggregating all the apis into a single module
import visibilities from "./visibilities";
import filters from "./filters";
import widgets from "./widgets";
import journeys from "./journeys";
import userPreferences from "./usersPreferences";
import filtersArchive from "./filtersArchive";
import workspace from "./workspace";
import orgColumns from "./orgColumns";
import flexiColumnsTemplate from "./flexiColumnsTemplate";
import dndShipments from "./dndShipments";
import dndWidgets from "./dndWidgets";
import dndHighlights from "./dndHighlights";
import dndSummaryTiles from "./dndSummaryTiles";
import BaseHandlerV1 from "./BaseHandlerV1.ts";
import metering from "./metering";
import userFilters from "./userFilters";
import templateDownload from "./templateDownload/index.ts";
import flexiColumnsReferencesTemplate from "./flexiColumnsReferencesTemplate";
import dashboards from "./dashboards";
import widgetCatalog from "./widgetCatalog";
import widgetOrchestrator from "./widgetOrchestrator/index.ts";
import updateWidget from "./updateWidgets/index.ts";
import orders from "./orders";
import locations from "./locations";

export default {
  visibilities,
  widgets,
  journeys,
  userPreferences,
  filters,
  filtersArchive,
  workspace,
  orgColumns,
  flexiColumnsTemplate,
  dndShipments,
  dndWidgets,
  dndHighlights,
  dndSummaryTiles,
  BaseHandlerV1,
  orders,
  locations,
  metering,
  userFilters,
  templateDownload,
  flexiColumnsReferencesTemplate,
  dashboards,
  widgetCatalog,
  widgetOrchestrator,
  updateWidget
};
